var map = {
	"./index.html": "2a19",
	"./pin-black-diamond.png": "3363",
	"./pin-bronze.png": "e243",
	"./pin-diamante.png": "c33d",
	"./pin-duplo-diamante.png": "f20c",
	"./pin-esmeralda.png": "4efe",
	"./pin-prata.png": "059c",
	"./pin-safira.png": "34a2",
	"./pin-triplo-diamante.png": "0fc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";